export default function onTab(event, editor, next) {
  event.preventDefault();

  if (event.shiftKey) {
    return editor.moveToAnchor().moveAnchorToStartOfPreviousBlock().moveFocusToEndOfPreviousBlock();
  }

  if (editor.isSelectionInLastTableCell()) {
    var tableId = editor.getCurrentTableId();
    editor.addTableRow(tableId);
  }

  return editor.moveToAnchor().moveAnchorToStartOfNextBlock().moveFocusToEndOfNextBlock();
}